var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SwatchesGroup', {
    attrs: {
      "activeGroup": _vm.activeGroup,
      "customStyle": _vm.customStyle,
      "groupName": _vm.groupName,
      "hasTitleProperties": _vm.hasTitleProperties(_vm.groupName),
      "hasTitle": _vm.getTabData(_vm.groupName).title,
      "hasSubTitle": _vm.getTabData(_vm.groupName).subtitle,
      "swatchesToRenderOrdered": _vm.swatchesToRenderOrdered
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }